var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-avatar',{attrs:{"tile":"","color":"blue"}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-alarm")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }